import { Link } from 'react-router-dom';
import { Product } from '@/hooks/api/models';
import { useProducts } from '@/hooks/api/0390_products';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { SimpleTextFormat } from '@/components/element/SimpleTextFormat';

export const ProductsElement = () => {
  const { _w_, me } = useCurrentWorkspace();
  const { data } = useProducts({ identifier: _w_!.identifier, include_invalidity: true });

  if (data == null) return <></>;

  if (data.length == 0)
    return (
      <div className="card-body pt-0">
        <p className="card-description text-sm">登録されている売上カテゴリがありません。</p>
      </div>
    );

  return (
    <div className="card-body pt-0">
      <div className="table-responsive">
        <table className="table align-items-center">
          <thead>
            <tr>
              <th
                className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                style={{ width: 55 }}
              >
                ステータス
              </th>
              <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">
                売上カテゴリ名
              </th>
              <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">
                カテゴリ有効フィールド
              </th>
              <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">メモ</th>
              <th className="text-secondary opacity-7" style={{ width: 55 }}></th>
            </tr>
          </thead>
          <tbody>
            {data.map((p) => (
              <tr key={`product-${p.id}`}>
                <td>
                  <span className={`badge badge-sm ${p.invalidity ? 'badge-warning' : 'badge-success'}`}>
                    {p.invalidity ? '無効' : '有効'}
                  </span>
                </td>
                <td>
                  <h6 className="mb-0">{p.name}</h6>
                </td>
                <td className="text-secondary text-xs font-weight-bold text-wrap">{productAvailableStr(p)}</td>
                <td className="text-secondary text-xs text-wrap">
                  <SimpleTextFormat content={p.description || ''} />
                </td>
                <td>
                  <Link
                    to={`/w/${_w_!.identifier}/setting/products/${p.id}/edit`}
                    className="btn btn-icon-only btn-outline-success"
                  >
                    <i className="fas fa-edit text-success text-sm"></i>
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const productAvailableStr = (p: Product): string => {
  const ary: string[] = [];
  if (p.spot_available) {
    ary.push('スポット金額');
  }
  if (p.monthly_available) {
    ary.push('月額金額');
  }
  if (p.contract_term_available) {
    ary.push('契約期間');
  }
  if (p.delivery_date_available) {
    ary.push('納品日');
  }
  return ary.join(' / ');
};
